const React = require('react');
const trim = require('mn-utils/trim');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const onEnterProvider = require('mn-utils/onEnterProvider');
const CheckIcon = require('@material-ui/icons/Check').default;
const {
  LINK_SIGN_IN,
} = require('../../../../constants/links');
const withState = require('../../../../utils/withState');
const {
  replaceLocation,
} = require('../../../../router');
const {
  openPopupWindow,
} = require('../../../../emitters/popup');
const {
  account$,
} = require('../../../../emitters/account');
const {
  resendVerificationCode,
  verificationLoading$,
  disabledResendVerificationCode$,
} = require('./emitters/resendVerification');
const Ripple = require('../../../dumb/Ripple');
const TextFieldI = require('../../../dumb/TextField/I');
const ButtonG = require('../../../dumb/Button/G');

const Base = require('./components/Base');
const TimerA = require('./components/Timer/A');


module.exports = withState((setState, self, onMount) => {
  let _codeNode;
  const changeProvider = changeProviderProvider(setState);
  const handleChangeCode = changeProvider('code');

  function handleCodeRef(node) {
    node && (_codeNode = node);
  }

  return (state, props) => {
    const {
      params,
    } = props;
    const email = decodeURIComponent(params.email || '');
    const {
      clicked,
    } = state;
    const code = state.code || '';
    const _code = trim(code);
    const disabled = !_code;

    function handleSubmit() {
      if (disabled) {
        setState({
          clicked: true,
        });
        return;
      }
      _codeNode && _codeNode.blur();
      account$
          .emailConfirm({
            code: _code,
          })
          .then(() => {
            replaceLocation({
              path: LINK_SIGN_IN,
            });
            openPopupWindow((setPopupState, popup) => {
              popup.className = 'bg181A1C.95*2';

              return (stateOfPopup) => {
                return (
                  <div className="rlv cF">
                    <div>
                      <CheckIcon
                        className="dB-i f46-i mhA"
                      />
                    </div>
                    <div className="mt30 f16 fw5 tc lh160%">
                      Email has been verified.<br/>
                      Please log in to continue.
                    </div>
                    <div className="mt40">
                      <ButtonG
                        className="w160 h48*2 mhA"
                        onClick={popup.close}
                      >OK</ButtonG>
                    </div>
                  </div>
                );
              };
            });
          });
    }


    return (
      <Base
        loading={state.verificationLoading}
        title="Create your account"
        content={(<div className="pt48@d">
          <TextFieldI
            label="Verification code"
            inputRef={handleCodeRef}
            error={clicked && disabled}
            value={code}
            onChange={handleChangeCode}
            onKeyPress={onEnterProvider(handleSubmit)}
          />
          <div className="hmin48 ph25 pv15 f12 fw3 lh18 lts0em tl c717275">
            Please enter the activation code we sent you to the email address <b>{email}</b>
          </div>
        </div>)}
        control={(<div>
          <Ripple
            className="layoutRow fhaC fvaC wmin270 ph15 h60 f16
              lh21 r3 cF ttU tdN olN usN b0 dn bg5B47FF
              bg4B37EF:not[.disabled]:h o50.disabled"
            disabled={clicked && disabled}
            onClick={handleSubmit}
          >Send</Ripple>
          <Ripple
            className="layoutRow fhaC fvaC wmin270 ph15 h60 f14 mt30
              lh21 r3 cF ttU tdN olN usN b0 dn bg5B47FF
              bg4B37EF:not[.disabled]:h o50.disabled"
            disabled={state.disabledResendVerificationCode}
            onClick={() => {
              account$
                  .resendConfirmationV2({
                    email: trim(email),
                  })
                  .then(() => {
                    resendVerificationCode();
                  });
            }}
          >
            Resend verification code <TimerA/>
          </Ripple>
        </div>)}
      />
    );
  };
}, {
  disabledResendVerificationCode: disabledResendVerificationCode$,
  verificationLoading: verificationLoading$,
});
